import { HomeIcon, UsersIcon, WrenchIcon } from "@heroicons/react/24/outline";

export const NAVIGATION_OPTIONS = [
  { name: "Home", icon: HomeIcon, href: "/" },
  { name: "Profile", icon: UsersIcon, href: "/login" },
  { name: "Settings", icon: WrenchIcon, href: "/settings" },
];
